/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_20552_50761)">
      <path
        d="M0.832031 9.99998C0.832031 9.99998 4.16536 3.33331 9.9987 3.33331C15.832 3.33331 19.1654 9.99998 19.1654 9.99998C19.1654 9.99998 15.832 16.6666 9.9987 16.6666C4.16536 16.6666 0.832031 9.99998 0.832031 9.99998Z"
        stroke="#010032"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        stroke="#010032"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_20552_50761">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const EyeIconShow2 = (props) => <Icon component={svg} {...props} />;

export default EyeIconShow2;
